import * as React from 'react';
import AromaticNoteForm from '../../components/AromaticNotes/AromaticNoteForm/AromaticNoteForm';
var AromaticNote = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432\u0430 \u0430\u0440\u043E\u043C\u0430\u0442\u043D\u0430 \u043D\u043E\u0442\u043A\u0430"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-5 offset-md-4" },
                    React.createElement(AromaticNoteForm, null))))));
};
export default AromaticNote;



//////////////////
// WEBPACK FOOTER
// ./src/views/AromaticNote/AromaticNote.tsx
// module id = 316
// module chunks = 0